import { columnNamesAndTooltipsMap } from "app/common/keyword-research/serp-players/consts";
import { translate } from "app/filters/i18nFilter";

import type { TextMode } from "./tableTypes";

export const getColumnTexts = (column: string, textMode: TextMode, entityText?: string) => {
    return translate(columnNamesAndTooltipsMap[column]?.[textMode], {
        entity: entityText,
    });
};
